import { LOCALES } from 'i18n/locales';

export const bookmarkIntl = {
    [LOCALES.ENGLISH]: {
        'bookmark.save.title': 'Save and share',
        'bookmark.save.message': 'Choose a name for your bookmark',

        'bookmark.save.placeholder': 'Bookmark name',
        'bookmark.save.input.arialabel': 'bookmark name input',

        'bookmark.button.text.cancel': 'Cancel',
        'bookmark.button.cancel.arialabel': 'cancel button',
        'bookmark.button.text.save': 'Save',
        'bookmark.button.save.arialabel': 'save button',

        'bookmark.button.menu.text': 'Save and share',
        'bookmark.menu.location': 'Bookmark & share this location',
        'bookmark.menu.aoi': 'Bookmark & share this Area',
        'bookmark.save.success.alert': '<b>Bookmark and shared link added:</b> Location saved to your <link>bookmarks</link> area and a shared link has been copied to your clipboard.',
        'bookmark.save.error': 'Something went wrong, please try to save again.',
        'bookmark.save.tooLong.error': 'Name exceeds 255 characters, please try again',
        'bookmark.save.tooSmall.error': 'Name not defined, please try again',
        'bookmark.i2d.drawAOI': 'Draw an area to \'Create PDF\'',

        'bookmark.button.makeEnquiry': 'Make enquiry',
        'bookmark.button.createWorkPack.title': 'Draw an area first to create a PDF',
        'bookmark.button.createWorkPack.tooltip': 'Map PDF cannot currently be created when using the line drawing tool.',
        'bookmark.button.makeEnquiry.title': 'Draw an area first to make an enquiry',
        'bookmark.button.bookmarksDisabled.title': 'You cannot create bookmarks that extend beyond your service area.'
    },
    [LOCALES.WELSH]: {
        'bookmark.save.title': 'Cadw a rhannu',
        'bookmark.save.message': 'Dewiswch enw ar gyfer eich nod tudalen',

        'bookmark.save.placeholder': 'Enw\'r nod tudalen',
        'bookmark.save.input.arialabel': 'mewnbwn enw\'r nod tudalen',

        'bookmark.button.text.cancel': 'Canslo',
        'bookmark.button.cancel.arialabel': 'botwm canslo',
        'bookmark.button.text.save': 'Cadw',
        'bookmark.button.save.arialabel': 'botwm cadw',

        'bookmark.button.menu.text': 'Cadw a rhannu',
        'bookmark.menu.location': 'Rhoi nod tudalen a rhannu\'r lleoliad hwn',
        'bookmark.menu.aoi': 'Nodi a rhannu\'r AOI hwn',
        'bookmark.save.success.alert': '<b>Nod tudalen a dolen wedi\'i rhannu wedi\'u hychwanegu:</b> Lleoliad wedi ei gadw yn eich maes <link>nodau tudalen</link> ac mae dolen wedi\'i rhannu wedi\'i chopïo i\'ch clipfwrdd.',
        'bookmark.save.error': 'Aeth rhywbeth o\'i le',
        'bookmark.save.tooLong.error': 'Mae\'r enw yn fwy na 255 nod',
        'bookmark.save.tooSmall.error': 'Enw\'r person heb ei ddiffinio, rhowch gynnig arall arni',
        'bookmark.i2d.drawAOI': '[Draw an area to \'Create PDF\']',

        'bookmark.button.makeEnquiry': '[Make Enquiry]',
        'bookmark.button.createWorkPack.title': '[Draw an area first to create a PDF]',
        'bookmark.button.createWorkPack.tooltip': '[Map PDF cannot currently be created when using the line drawing tool.]',
        'bookmark.button.makeEnquiry.title': '[Draw an area first to make an enquiry]',
        'bookmark.button.bookmarksDisabled.title': '[You cannot create bookmarks that extend beyond your service area.]'
    }
};
